/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LiveBiddingTickerStatus {
  Idle = 'idle',
  Paused = 'paused',
  Live = 'live'
}
